import { checkSessionExpiry } from "../../assets";
import { USER_REQUEST } from "../actions/utilities";
const INITIAL_STATE = {
  loginLoading: false,
  loginSuccess: false,
  loginFailure: false,
  loginError: null,
  user: null,

  loginCovisTourLoading: false,
  loginCovisTourSuccess: false,
  loginCovisTourFailure: false,
  loginCovisTourError: null,
  loginCovisTour: [],

  teamLeadsLoading: false,
  teamLeadsSuccess: false,
  teamLeadsFailure: false,
  teamLeadsError: null,
  teamLeads: null,

  teamMembersLoading: false,
  teamMembersSuccess: false,
  teamMembersFailure: false,
  teamMembersError: null,
  teamMembers: [],

  employeesSelectListLoading: false,
  employeesSelectListSuccess: false,
  employeesSelectListFailure: false,
  employeesSelectListError: null,

  employeesSelectListByRoleLoading: false,
  employeesSelectListByRoleSuccess: false,
  employeesSelectListByRoleFailure: false,
  employeesSelectListByRoleError: null,

  employeesListLoading: false,
  employeesListSuccess: false,
  employeesListFailure: false,
  employeesListError: null,

  updateUserDepartmentLoading: false,
  updateUserDepartmentSuccess: false,
  updateUserDepartmentFailure: false,
  updateUserDepartmentError: null,

  employeesSelectList: [],
  employeesSelectListByRole: [],
  employeesList: [],

  sessionExpire: checkSessionExpiry(),
  landingModal: true,
  loadingTour: false,
};

export const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USER_REQUEST.USER_SIGNIN_REQUEST:
      return {
        ...state,
        loginLoading: true,
        loginSuccess: false,
        loginFailure: false,
        loginError: null,
      };
    case USER_REQUEST.USER_SIGNIN_FAILURE:
      return {
        ...state,
        loginLoading: false,
        loginSuccess: false,
        loginFailure: true,
        loginError: action.payload,
      };
    case USER_REQUEST.USER_SIGNIN_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        loginSuccess: true,
        loginFailure: false,
        loginError: null,
        user: action.payload,
      };

    case USER_REQUEST.USER_SIGNIN_REQUEST:
      return {
        ...state,
        loginCovisTourLoading: true,
        loginCovisTourSuccess: false,
        loginCovisTourFailure: false,
        loginCovisTourError: null,
      };
    case USER_REQUEST.USER_SIGNIN_FAILURE:
      return {
        ...state,
        loginCovisTourLoading: false,
        loginCovisTourSuccess: false,
        loginCovisTourFailure: true,
        loginCovisTourError: action.payload,
      };
    case USER_REQUEST.USER_SIGNIN_SUCCESS:
      return {
        ...state,
        loginCovisTourLoading: false,
        loginCovisTourSuccess: true,
        loginCovisTourFailure: false,
        loginCovisTourError: null,
        loginCovisTour: action.payload,
      };

    case USER_REQUEST.GET_TEAMLEADS_REQUEST:
      return {
        ...state,
        teamLeadsLoading: true,
        teamLeadsSuccess: false,
        teamLeadsFailure: false,
        teamLeadsError: null,
      };
    case USER_REQUEST.GET_TEAMLEADS_SUCCESS:
      return {
        ...state,
        teamLeadsLoading: false,
        teamLeadsSuccess: true,
        teamLeadsFailure: false,
        teamLeadsError: null,
        teamLeads: action.payload,
      };
    case USER_REQUEST.GET_TEAMLEADS_FAILURE:
      return {
        ...state,
        teamLeadsLoading: false,
        teamLeadsSuccess: false,
        teamLeadsFailure: true,
        teamLeadsError: action.payload,
      };
    case USER_REQUEST.GET_TEAM_MEMBERS_REQUEST:
      return {
        ...state,
        teamMembersLoading: true,
        teamMembersSuccess: false,
        teamMembersFailure: false,
        teamMembersError: null,
        teamMembers: [],
      };

    case USER_REQUEST.GET_TEAM_MEMBERS_SUCCES:
      return {
        ...state,
        teamMembersLoading: false,
        teamMembersSuccess: true,
        teamMembersFailure: false,
        teamMembersError: null,
        teamMembers: action.payload,
      };

    case USER_REQUEST.GET_TEAM_MEMBERS_FAILURE:
      return {
        ...state,
        teamMembersLoading: false,
        teamMembersSuccess: false,
        teamMembersFailure: true,
        teamMembers: [],
        teamMembersError: action.payload,
      };
    case USER_REQUEST.GET_EMPLOYEES_SELECTLIST_REQUEST:
      return {
        ...state,
        employeesSelectListLoading: true,
        employeesSelectListSuccess: false,
        employeesSelectListFailure: false,
        employeesSelectListError: null,
        employeesSelectList: [],
      };

    case USER_REQUEST.GET_EMPLOYEES_SELECTLIST_SUCCESS:
      // console.log('reducer =>', action.info);
      state.employeesSelectList = action.payload;
      if (action.info) {
        if (action.info.fillTeamLeads) {
          state.teamLeads = action.payload.filter((e) => e.isTeamLead === true);
          state.teamMembers = action.payload;
        }
      }
      return {
        ...state,
        employeesSelectListLoading: false,
        employeesSelectListSuccess: true,
        employeesSelectListFailure: false,
        employeesSelectListError: null,
        employeesSelectList: action.payload,
      };

    case USER_REQUEST.GET_EMPLOYEES_SELECTLIST_FAILURE:
      return {
        ...state,
        employeesSelectListLoading: false,
        employeesSelectListSuccess: false,
        employeesSelectListFailure: true,
        employeesSelectListError: action.payload,
      };
    case USER_REQUEST.GET_EMPLOYEES_SELECT_LIST_BY_ROLE_REQUEST:
      return {
        ...state,
        employeesSelectListByRoleLoading: true,
        employeesSelectListByRoleSuccess: false,
        employeesSelectListByRoleFailure: false,
        employeesSelectListByRoleError: null,
        employeesSelectListByRole: [],
      };

    case USER_REQUEST.GET_EMPLOYEES_SELECT_LIST_BY_ROLE_SUCCESS:
      return {
        ...state,
        employeesSelectListByRoleLoading: false,
        employeesSelectListByRoleSuccess: true,
        employeesSelectListByRoleFailure: false,
        employeesSelectListByRoleError: null,
        employeesSelectListByRole: action.payload,
      };

    case USER_REQUEST.GET_EMPLOYEES_SELECT_LIST_BY_ROLE_FAILURE:
      return {
        ...state,
        employeesSelectListByRoleLoading: false,
        employeesSelectListByRoleSuccess: false,
        employeesSelectListByRoleFailure: true,
        employeesSelectListByRoleError: action.payload,
      };

    case USER_REQUEST.GET_EMPLOYEES_LIST_REQUEST:
      return {
        ...state,
        employeesListLoading: true,
        employeesListSuccess: false,
        employeesListFailure: false,
        employeesListError: null,
        employeesList: [],
      };

    case USER_REQUEST.GET_EMPLOYEES_LIST_SUCCESS:
      return {
        ...state,
        employeesListLoading: false,
        employeesListSuccess: true,
        employeesListFailure: false,
        employeesListError: null,
        employeesList: action.payload,
      };

    case USER_REQUEST.GET_EMPLOYEES_LIST_FAILURE:
      return {
        ...state,
        employeesListLoading: false,
        employeesListSuccess: false,
        employeesListFailure: true,
        employeesListError: action.payload,
        employeesList: [],
      };

    /////
    case USER_REQUEST.GET_EMPLOYEES_LIST_REQUEST:
      return {
        ...state,
        updateUserDepartmentLoading: true,
        updateUserDepartmentSuccess: false,
        updateUserDepartmentFailure: false,
        updateUserDepartmentError: null,
      };

    case USER_REQUEST.GET_EMPLOYEES_LIST_SUCCESS:
      return {
        ...state,
        updateUserDepartmentLoading: false,
        updateUserDepartmentSuccess: true,
        updateUserDepartmentFailure: false,
        updateUserDepartmentError: null,
      };

    case USER_REQUEST.GET_EMPLOYEES_LIST_FAILURE:
      return {
        ...state,
        updateUserDepartmentLoading: false,
        updateUserDepartmentSuccess: true,
        updateUserDepartmentFailure: true,
        updateUserDepartmentError: action.payload,
      };
    case USER_REQUEST.UPDATE_DEPARTMENT_REQUEST:
      return {
        ...state,
        updateUserDepartmentLoading: true,
        updateUserDepartmentSuccess: false,
        updateUserDepartmentFailure: false,
        updateUserDepartmentError: null,
      };
    case USER_REQUEST.UPDATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        updateUserDepartmentLoading: false,
        updateUserDepartmentSuccess: true,
        updateUserDepartmentFailure: false,
        updateUserDepartmentError: null,
      };

    case USER_REQUEST.UPDATE_DEPARTMENT_FAILURE:
      return {
        ...state,
        updateUserDepartmentLoading: false,
        updateUserDepartmentSuccess: false,
        updateUserDepartmentFailure: true,
        updateUserDepartmentError: action.payload,
      };
    case USER_REQUEST.SET_SESSION_EXPIRE_STATE:
      return {
        ...state,
        sessionExpire: action.payload,
      };
    case USER_REQUEST.SET_LANDING_MODAL_STATE:
      return {
        ...state,
        landingModal: action.payload,
      };
    case USER_REQUEST.SET_LOADING_TOUR_STATE:
      return {
        ...state,
        loadingTour: action.payload,
      };
    default:
      return state;
  }
};
